

















import { Vue, Component } from "vue-property-decorator";
import { Calendar, DropdownMenu, DropdownItem } from "vant";

export default class extends Vue {
  back() {
    history.back();
  }
}
